import { render, staticRenderFns } from "./commerce-payouts.vue?vue&type=template&id=45c1cb46&scoped=true&lang=pug&"
import script from "./commerce-payouts.vue?vue&type=script&lang=js&"
export * from "./commerce-payouts.vue?vue&type=script&lang=js&"
import style0 from "./commerce-payouts.vue?vue&type=style&index=0&id=45c1cb46&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1cb46",
  null
  
)

export default component.exports